import React from 'react';
import { useParams, useLocation } from 'react-router-dom';

import { slugify } from 'helpers/text';
import { get } from 'helpers/utilities';

import JobDetailHeader from 'components/JobDetailHeader';
import JobDetailBody from 'components/JobDetailBody';
import Meta from 'components/Meta';
import NavigationThemeSetter from 'components/NavigationThemeSetter';
import useJobBenefits from '../../hooks/useJobBenefits';
import useGreenHouseJobs from '../../hooks/useGreenHouseJobs';

const getURLParam = location => {
  const locationURL = location.search.split('=');
  return locationURL.map(item => item.replace(/[?/]/g, ''));
};

const JobdetailContent = ({ jobDetail }) => {
  const location = useLocation();
  const URLParams = location.search ? getURLParam(location) : null;
  const locationSlug = URLParams ? URLParams[1] : slugify(get(jobDetail, 'offices[0].name', ''));

  const jobBenefits = useJobBenefits(locationSlug);

  return <JobDetailBody data={jobDetail} jobBenefits={jobBenefits} URLParams={URLParams} />;
};

const Job = ({ active }) => {
  const { job: jobID } = useParams(`/page/careers/:job`);
  let jobDetail = null;
  try {
    const jobs = useGreenHouseJobs();
    jobDetail = jobs.find(job => job.id === parseInt(jobID, 10));

    if (!jobDetail) {
      throw new Error('No Entry');
    }
  } catch (error) {
    // Error Finding requested Job, Redirect to careers section
    window.location.href = '/careers';
  }

  const metaDetails = {
    entryTitle: get(jobDetail, 'title', '')
  };
  return (
    <>
      <Meta metaDetails={metaDetails} active={active} gtm={{ type: 'Job' }} />
      {jobDetail && (
        <NavigationThemeSetter navTheme="black">
          <section>
            <JobDetailHeader data={jobDetail} />
            <JobdetailContent jobDetail={jobDetail} />
          </section>
        </NavigationThemeSetter>
      )}
    </>
  );
};

export default Job;
